// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__3HNG8","mainContainer":"styles_mainContainer__2GyIU"};